import { useMemo } from "react";
import { SocialNetwork, SocialNetworkLinkItem } from "./types";
import type { SiteUrls } from "../../../../types/coreApiMirror";

export function useSocialNetworksList(
  siteUrls: SiteUrls,
): SocialNetworkLinkItem[] {
  return useMemo(() => {
    const socialNetworks = [
      {
        name: SocialNetwork.Instagram,
        url: siteUrls.instagram_url,
        imgSrc: "/instagram_icon.svg",
        altText: "Instagram logo",
      },
      {
        name: SocialNetwork.Facebook,
        url: siteUrls.facebook_url,
        imgSrc: "/facebook_icon.svg",
        altText: "Facebook logo",
      },
      {
        name: SocialNetwork.TikTok,
        url: siteUrls.tiktok_url,
        imgSrc: "/tiktok_icon.svg",
        altText: "Tiktok logo",
      },
      {
        name: SocialNetwork.Twitter,
        url: siteUrls.twitter_url,
        imgSrc: "/twitter_icon.svg",
        altText: "Twitter logo",
      },
    ];

    return socialNetworks.filter(
      (network) => network.url && network.url.length > 0,
    );
  }, [
    siteUrls.instagram_url,
    siteUrls.facebook_url,
    siteUrls.tiktok_url,
    siteUrls.twitter_url,
  ]);
}
